import { useDispatch as p, useSelector as f } from "react-redux";
import { setUser as d, setShowMenu as h } from "../services/DataStoreService/reducers/AppReducer.js";
import { removeCookie as g } from "../utils/generators.js";
import { closeCheckout as w, closeCommenter as A, closeConfirm as U, closeDiagnosisLoader as C, closeResetAlert as P, closeSnackBar as S } from "../utils/popups.js";
function D() {
  const e = p(), { user: s } = f((o) => o.app.datastate), n = s?._id != null, r = ["/login", "/register", "/recovery", "/verify-otp"];
  function c(o, u = 1e3) {
    if (!n) return;
    const t = window.location.pathname + window.location.search, a = r.some((m) => t.startsWith(m)) ? o : `${o}?redirect=${encodeURIComponent(t)}`;
    e(d({})), g(), i(), setTimeout(() => {
      window.location.href = a;
    }, u);
  }
  function i() {
    w(), A(), U(), C(), P(), S(), l();
  }
  function l() {
    e(h(!1));
  }
  return c;
}
export {
  D as useForceLogoutUser
};
